import ga from "@starter/Framework/Common/GoogleAnalytics";
import { TrackEventListParameters } from "@starter/Framework/Common/GoogleAnalytics/trackers/trackEventList";

/* ---------------------------------------------------------------------------------------------------- */
// https://developers.google.com/analytics/devguides/collection/ga4/reference/events#add_shipping_info
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackAddShippingInfoItem extends Toolkit.GoogleAnalytics.AnyProductItem {}

export interface TrackAddShippingInfoParameters
    extends TrackEventListParameters<"currency" | "value" | "shipping_tier", null, TrackAddShippingInfoItem> {}

const trackAddShippingInfo = (
    parameters: TrackAddShippingInfoParameters,
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.track.eventList({ action: "add_shipping_info", ...parameters }, options);
};

export default trackAddShippingInfo;
